import { cn } from "src/lib/utils";
import style from "./loading.module.css";

export default function Loading({ className }: { className?: string }) {
  return (
    <div
      className={`${cn("flex justify-center gap-8", className)} ${
        style.loading
      }`}
    >
      <img
        src="/images/beer-full.svg"
        style={{
          height: "4rem",
          transform: "scaleX(-1)",
          paddingTop: "1rem",
          paddingBottom: "0.5rem",
          position: "relative",
          right: "-0.25rem",
        }}
        alt=""
      />
      <img src="/images/beer-full.svg" style={{ height: "4rem" }} alt="" />
    </div>
  );
}
